import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../constants/constants";
import { getCurrentToken, getValueFromStorage } from "../helpers/helpers";

export const EventsApi = createApi({
  reducerPath: "events",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("Content-type", "application/json");
      headers.set("authorization", `Bearer ${getCurrentToken()}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getEvents: builder.query({
      query: ({
        currentPage = 1,
        resultPerPage = 10000,
        ongoing = "",
        upcoming = "",
        past = "",
        attendeeId = "",
      }) => {
        return {
          url: `api/event`,
          method: "GET",
          params: {
            current_page: currentPage,
            result_per_page: resultPerPage,
            ongoing: ongoing,
            upcoming: upcoming,
            past: past,
            attendee_id: attendeeId,
          },
        };
      },
    }),
    get_event_by_userId: builder.query({
      query: (userId) => {
        return {
          url: `api/event/attendee/${userId}`,
          method: "GET",
        };
      },
    }),

    getEventByID: builder.query({
      query: (id) => ({
        url: `/api/event`,
        method: "GET",
        params: {
          event_id: id,
        },
      }),
    }),

    putEvents: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `api/event/${id}`,
          method: "PUT",
          body: body,
        };
      },
    }),
    addEvents: builder.mutation({
      query: (body) => ({
        url: `api/event`,
        method: "POST",
        body: body,
      }),
    }),
    requestDeleteEventCode: builder.mutation({
      query: (id) => ({
        url: `api/event/${id}/delete-code`,
        method: "POST",
      }),
    }),
    deleteEvent: builder.mutation({
      query: ({ id, authCode }) => {
        return {
          url: `api/event/${id}`,
          method: "DELETE",
          body: { authCode },
        };
      },
    }),
  }),
});

// export const EventsApi = createApi({
//   reducerPath: "events",
//   baseQuery: fetchBaseQuery({
//     baseUrl: BASE_URL,
//     prepareHeaders: (headers) => {
//       headers.set("Content-Type", "application/json");
//       headers.set("Authorization", `Bearer ${getCurrentToken()}`);
//       return headers;
//     },
//   }),
//   tagTypes: ["Events"], 
//   endpoints: (builder) => ({
//     getEvents: builder.query({
//       query: ({ currentPage = 1, resultPerPage = 10000, ongoing, upcoming, past, attendeeId }) => ({
//         url: `api/event`,
//         method: "GET",
//         params: {
//           current_page: currentPage,
//           result_per_page: resultPerPage,
//           ...(ongoing && { ongoing }),
//           ...(upcoming && { upcoming }),
//           ...(past && { past }),
//           ...(attendeeId && { attendee_id: attendeeId }),
//         },
//       }),
//       providesTags: ["Events"], 
//     }),

//     getEventByUserId: builder.query({
//       query: (userId) => ({
//         url: `api/event/attendee/${userId}`,
//         method: "GET",
//       }),
//       providesTags: ["Events"],
//     }),

//     getEventByID: builder.query({
//       query: (id) => ({
//         url: `api/event/${id}`, // ✅ Dynamic ID directly in URL
//         method: "GET",
//       }),
//       providesTags: (result, error, id) => [{ type: "Events", id }], // ✅ Cache specific event
//     }),

//     putEvents: builder.mutation({
//       query: ({ id, body }) => ({
//         url: `api/event/${id}`,
//         method: "PUT",
//         body,
//       }),
//       invalidatesTags: (result, error, { id }) => [{ type: "Events", id }], // ✅ Invalidate updated event cache
//     }),

//     addEvents: builder.mutation({
//       query: (body) => ({
//         url: `api/event`,
//         method: "POST",
//         body,
//       }),
//       invalidatesTags: ["Events"], // ✅ Invalidate cache after adding
//     }),

//     deleteEvent: builder.mutation({
//       query: (id) => ({
//         url: `api/event/${id}`,
//         method: "DELETE",
//       }),
//       invalidatesTags: ["Events"], // ✅ Remove deleted event from cache
//     }),
//   }),
// });


export const {
  useGetEventsQuery,
  useGet_event_by_userIdQuery,
  useGetEventByIDQuery,
  usePutEventsMutation,
  useLazyGetEventsQuery,
  useLazyGetEventByIDQuery,
  useAddEventsMutation,
  useDeleteEventMutation,
  useRequestDeleteEventCodeMutation,
} = EventsApi;
